import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import CategoriesBar from './components/CategoriesBar';
import SubCategory from './components/SubCategory';
import ProductPreview from './components/ProductPreview';
import OrderHistoryContainer from '../../../OrderHistory/OrderHistoryContainer';
import FavouritesListContainer from '../../../Favourites/FavouritesList/FavouritesListContainer';
import CartMenuSidebarContainer from '../../../CartMenuSidebar/CartMenuSidebarContainer';
import ComboList from '../../../Combo/ComboList/ComboList';

const SubCategoriesWrapper = styled.div`
  display: grid;
  grid-gap: 4px;
  margin-top: 8px;
  @media (max-width: 786px) {
    margin: 4px -20px 0 -20px;
  }
`;

const ProductPreviewsWrapper = styled.div`
  display: grid;
  grid-gap: 24px 40px;
  grid-template-columns: ${(props) =>
    `repeat(${props.theme.productPreviewsPerRow}, 1fr)`};
  grid-gap: 20px;
  padding-bottom: 4px;
  margin-top: 10px;
  @media (max-width: 786px) {
    grid-template-columns: 1fr;
  }
`;

const ProductCartWrapper = styled.div`
  max-width: 1500px;
  margin: 0 5%;

  display: grid;
  grid-template-columns: 1fr 264px;
  grid-gap: 32px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 786px) {
    margin-top: -50px;
    display: block;
    margin-top: 12px;
  }
`;

const Menu = ({
  categories,
  products,
  combos,
  handleProductPreviewClick,
  handleComboPreviewClick,
  dontSelectMyOrders,
}) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(
    dontSelectMyOrders ? categories[1].category_id : categories[0].category_id
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedCategoryId]);

  const selectedCategory = categories.find(
    (category) => category.category_id === selectedCategoryId
  );

  const subCategories = selectedCategory.sub_categories;

  const visibleProducts = selectedCategory.products.map((productWithJustId) =>
    products.find(
      (product) => product.product_id === productWithJustId.product_id
    )
  );

  const featured = visibleProducts?.filter((p) => p.is_featured) || [];
  const nonFeatured =
    visibleProducts?.filter((p) => !p.is_featured) || visibleProducts || [];

  const orderedProducts = [...featured, ...nonFeatured];

  const selectProduct = (productId) =>
    products.find((product) => product.product_id === productId);

  const filteredCategory = categories.filter(
    (category) =>
      (category.products.length == 1 &&
        selectProduct(category.products[0].product_id)) ||
      category.products.length > 1 ||
      category.name === 'Combos' ||
      category.name === 'My Orders'
  );

  return (
    <div>
      <CategoriesBar
        id='MenuA-CategoriesBar'
        categories={filteredCategory}
        selectedCategoryId={selectedCategoryId}
        changeCategory={setSelectedCategoryId}
      />
      <SubCategoriesWrapper>
        {subCategories.map((subCategory) =>
          subCategory.name === 'My Favourites' ? (
            <FavouritesListContainer />
          ) : subCategory.name === 'My Orders' ? (
            <OrderHistoryContainer isCategory />
          ) : (
            <SubCategory
              id='MenuA-SubCategory'
              key={subCategory.category_id}
              subCategory={subCategory}
              products={products}
              handleProductPreviewClick={handleProductPreviewClick}
            />
          )
        )}
      </SubCategoriesWrapper>
      <ComboList
        id='MenuA-ComboList'
        combos={combos}
        handleComboPreviewClick={handleComboPreviewClick}
      />
      <ProductCartWrapper>
        {orderedProducts && (
          <ProductPreviewsWrapper>
            {orderedProducts.map((product) => {
              if (product) {
                return (
                  <ProductPreview
                    id='MenuA-ProductPreview'
                    key={product.product_id}
                    product={product}
                    handleProductPreviewClick={handleProductPreviewClick}
                  />
                );
              }
            })}
          </ProductPreviewsWrapper>
        )}
        <CartMenuSidebarContainer />
      </ProductCartWrapper>
    </div>
  );
};

export default Menu;
